<!-- <mat-toolbar color="primary">
    <button [fxShow.lt-md]="true" [fxShow]="false"  mat-icon-button (click)="openSidenav()">
        <mat-icon>menu</mat-icon>
    </button>
    <span>OebsConfig</span>
</mat-toolbar> -->
<div class="content" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px" [@routeAnimation]="true">
    <mat-card >
        <form [formGroup]="oebsInfo" fxLayoutGap="16px">
            <mat-form-field>
                <mat-select placeholder="Accounting Distribution List" formControlName="accDist">
                    <mat-option value="">--</mat-option>
                    <mat-option *ngFor="let accDist of accDistList" [value]="accDist.value">{{accDist.name}}</mat-option>
                </mat-select>
            </mat-form-field>
            <button mat-raised-button color="primary" [disabled]="!isValid" (click)="GetAccDistInfo()">Save AccDist Info</button>
            <button mat-raised-button color="warn" [disabled]="!isValid" (click)="DeleteAccDistInfo()">Delete AccDist Info</button>
            <!-- <button mat-raised-button color="primary" (click)="onSubmit()">Add Override</button> -->
        </form>
    </mat-card>
</div>